import { Col } from "antd";
import styled, { css } from "styled-components";

export const ManyAuthorsContainer = styled.div`
  .slick-prev {
    top: 40% !important;
    margin: 0 1rem 0 1rem;
  }

  .slick-prev:before {
    color: ${({ theme }) => theme.colors.primary};
  }

  .slick-next {
    top: 40% !important;
    margin: 0 1rem 0 1rem;
  }

  .slick-next:before {
    color: ${(props) => props?.theme.colors.primary};
  }

  .slick-slider.slick-initialized {
    margin: 0;
  }
`;

export const AuthorsContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .link h1,
  div.author-bio span {
    color: ${({ theme }) => theme.colors.textColor};
  }

  .link {
    width: 100%;
    justify-content: center;
    display: flex;
  }

  &.gx-testimonial {
    margin-bottom: 1.25rem;
  }

  .badges-container {
    display: flex;
    justify-content: center;

    img {
      width: 1.625rem;
      height: 1.625rem;
    }

    img:not(:first-child) {
      margin-left: 0.5rem;
    }
  }
`;

export const ContentCol = styled(Col)<{ custom?: string }>`
  text-align: center;

  p,
  span {
    color: ${({ theme }) => theme.colors.textColor};
  }

  border-right: ${({ custom }) =>
    custom === "true" ? "1px solid #242424" : ""};

  ${(props) =>
    props.custom === "true" &&
    css`
      margin-bottom: 0.938rem !important;
    `}

  @media(max-width: 31.25rem) {
    && .gx-text-grey {
      font-size: 0.625rem;
    }
  }
`;

export const ColInfoUser = styled(Col)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;

  cursor: pointer;

  > h1 {
    margin: 25px 0px 5px 0px;
    text-align: center;
  }

  .author-bio {
    color: #262626;
    display: flex;
    justify-content: center;

    span {
      text-align: center;
      color: ${({ theme }) => theme.colors.textColor};
    }
  }
`;
